import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./Layout";
import Login from "./Login";
import Register from "./Register";
import HomePage from "./HomePage";
import GamePage from "./GamePage";
import ESportPage from "./ESportPage";
import MusicPage from "./MusicPage";
import FullPage from "./FullPage";
import WalletPage from "./WalletPage";
import DepositPage from "./DepositPage";
import WithdrawPage from "./WithdrawPage";
import ViewPersonal from "./ViewPersonal";
import PackageInfo from "./PackageInfo";
import ViewVideo from "./ViewVideo";
import PlayPage from "./PlayPage";

export default function App() {
  const [user, setUser] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch {
        localStorage.removeItem("user");
      }
    }
    setIsLoaded(true);
  }, []);

  const handleLogin = (userData) => {
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = async () => {
    if (user) {
      await fetch("http://localhost/api/logout_user.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: user.username }),
      }).catch(console.error);
    }
    localStorage.removeItem("user");
    setUser(null);
    window.location.href = "/login"; // ✅ Redirect otomatis ke halaman login
  };

  if (!isLoaded) return null;

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            user ? <Navigate to="/" replace /> : <Login onLogin={handleLogin} />
          }
        />
        <Route
          path="/register"
          element={user ? <Navigate to="/" replace /> : <Register />}
        />
        <Route
          path="/*"
          element={
            user ? (
              <Layout user={user} onLogout={handleLogout}>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/viewpersonal" element={<ViewPersonal />} />
                  <Route path="/game" element={<GamePage />} />
                  <Route path="/esport" element={<ESportPage />} />
                  <Route path="/music" element={<MusicPage />} />
                  <Route path="/fullPage" element={<FullPage />} />
                  <Route path="/packageinfo" element={<PackageInfo />} />
                  <Route path="/wallet" element={<WalletPage />} />
                  <Route path="/deposit" element={<DepositPage />} />
                  <Route path="/viewvideo" element={<ViewVideo />} />
                  <Route path="/withdraw" element={<WithdrawPage />} />
                   <Route path="/play" element={<PlayPage />} />
                </Routes>
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
